import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type LoginRequestData = {
    line_uid: string,
    login: string,
    password: string,
};

function login(data: LoginRequestData): Promise<DefaultResponseData> {
    return fetchData('api/login', {
        method: 'POST',
        body: JSON.stringify({
            ...data,
        }),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { login };
